module.exports = __webpack_public_path__ + "img/face-5.be80ba31.jpg";